import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { toast } from '../hooks/use-toast';
import api from '../utils/api';
import { Star } from 'lucide-react';

const FeedbackPage = () => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    setSaving(true);
    try {
      await api.post('/feedback', { rating: rating || undefined, message });
      toast({ title: 'Thanks for your feedback!' });
      setRating(0);
      setMessage('');
    } catch (error) {
      toast({
        title: 'Failed to send feedback',
        description: error?.error?.message || error?.message,
        variant: 'destructive',
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-3xl font-bold">Feedback</h1>
      </div>

      <Card className="p-6 space-y-4">
        <p className="text-sm text-gray-600">
          Tell us what&apos;s working, what&apos;s not, or what you&apos;d like to see next.
        </p>

        <div>
          <Label>Rating</Label>
          <div className="flex items-center gap-1 mt-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                onClick={() => setRating(star)}
                onMouseEnter={() => setHoverRating(star)}
                onMouseLeave={() => setHoverRating(0)}
                className="p-0.5"
              >
                <Star
                  className={`w-6 h-6 ${
                    star <= (hoverRating || rating)
                      ? 'fill-orange-400 text-orange-400'
                      : 'text-gray-300'
                  }`}
                />
              </button>
            ))}
          </div>
        </div>

        <div>
          <Label htmlFor="feedbackMessage">Your feedback *</Label>
          <Textarea
            id="feedbackMessage"
            rows={5}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Share your thoughts..."
          />
        </div>

        <Button
          className="bg-orange-500 hover:bg-orange-600"
          onClick={handleSubmit}
          disabled={saving || !message.trim()}
        >
          {saving ? 'Sending...' : 'Send Feedback'}
        </Button>
      </Card>
    </div>
  );
};

export default FeedbackPage;
